// type helpers
export const reverse = <T extends object>(gEnum: T): Map<string, T> =>
  Object.entries(gEnum).reduce((acc, [k, v]) => acc.set(v, k) && acc, new Map());

export const enumValueGuardFactory =
  <T>(mapping: Map<string, T>) =>
  (group: string): keyof T | undefined =>
    mapping.has(group) ? <keyof T>group : undefined;
